import api from "@/api/configApi";
import {headers} from "@/api/headers";
export const listarEventosActivos = async({commit}) => {
    const eventosActivos= await  api.get('listarEventosActivos',{headers:headers});
    const eventActivos = eventosActivos.data.data;
    commit('setEventosActivos',eventActivos);
}    
